import type { GeometryPadWidgetConfig } from '../geometrypad.model';

export const SINGLE_SQUARE_PRESET: GeometryPadWidgetConfig = {
  id: 'single-square',
  type: 'geometrypad',
  params: {
    elements: {
      sq1: {
        type: 'Square',
        params: { s: 5 },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: false },
      label: { coloring: true },
    },
  },
  behavior: {
    interactive: ['sq1.point.A', 'sq1.point.B'],
  },
};
